import { gql } from 'graphql-request';

import { FRAGMENT_LISTING_STATS } from '@hcs/cerberus';

export const FRAGMENT_PLACE_LOOKUP_FIELDS = gql`
  fragment PlaceLookupFields on PlaceDetails {
    countyName
    formattedAddress
    locality
    name
    placeId
    placeType
    region
    shape
    location {
      latitude
      longitude
    }
    altNames
    fips
    mlsCoverage {
      level
    }
    viewport {
      northeastLatitude
      northeastLongitude
      southwestLatitude
      southwestLongitude
    }
    zipcodes
    msas
  }
`;

export const QUERY_PLACE_LOOKUP = gql`
  ${FRAGMENT_PLACE_LOOKUP_FIELDS}
  query PlaceLookup($placeIdInput: PlaceIdInput!) {
    # HC CAPABILITY: platform-search-experience
    # HC CAPABILITY: pexp-product-access
    # HC CAPABILITY: market-insights-product-access
    lookupPlace(id: $placeIdInput) {
      place {
        ...PlaceLookupFields
      }
    }
  }
`;

export const QUERY_PLACE_LOOKUP_WITH_LISTING_STATS = gql`
  # HC CAPABILITY: market-insights-product-access
  ${FRAGMENT_PLACE_LOOKUP_FIELDS}
  ${FRAGMENT_LISTING_STATS}
  query PlaceLookupWithListingStats(
    $placeIdInput: PlaceIdInput!
    $fromDate: Date
    $toDate: Date
  ) {
    lookupPlace(id: $placeIdInput) {
      place {
        ...PlaceLookupFields
        listingStats {
          latestStats {
            ...ListingStats
          }
          timeSeries(fromDate: $fromDate, toDate: $toDate, order: ASCENDING) {
            ...ListingStats
          }
        }
        rentalListingStats {
          latestStats {
            ...ListingStats
          }
          timeSeries(fromDate: $fromDate, toDate: $toDate, order: ASCENDING) {
            ...ListingStats
          }
        }
      }
    }
  }
`;
